import React from 'react';
import { Table } from 'semantic-ui-react';
import { columnName, columnRole, columnEmail } from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';

const UsergroupUsersTableColumns = ({ allowRemove }) => (
  <Table.Row className="aridhia-usergroup-users-table-columns">
    <UnsortedColumn columnId={columnName} />
    <UnsortedColumn columnId={columnEmail} />
    <UnsortedColumn columnId={columnRole} />
    {allowRemove && (<UnsortedColumn />)}
  </Table.Row>
);

export default UsergroupUsersTableColumns;
